import { render } from "./DateAgeBadge.vue?vue&type=template&id=5b2e03c6&scoped=true"
import script from "./DateAgeBadge.vue?vue&type=script&lang=js"
export * from "./DateAgeBadge.vue?vue&type=script&lang=js"

import "./DateAgeBadge.vue?vue&type=style&index=0&id=5b2e03c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2e03c6"]])

export default __exports__